import React from 'react';
import { connect } from 'react-redux';
import { MODALS } from '../../constants';
import { getModalData } from '../../selectors/common';
import PlayersTemplatePreview from './PlayersTemplatePreview';
import AddPlayersTemplateSection from './Soccer/AddPlayersTemplateSection';
import TennisAddLiveTemplateSection from './Tennis/AddLiveTemplateSection';
import AddLiveTemplateSection from './Soccer/LiveTemplate/AddLiveTemplateSection';

const mapToProps = (state) => ({
  modalData: getModalData(state),
});
const PlayersTemplateModals = (props) => {
  switch (props.activeModal) {
    case MODALS.PLAYERS_TEMPLATE_ADD:
      return (
        <AddPlayersTemplateSection
          leagues={props.leagues}
          setOpenModal={props.setOpenModal}
          activeModal={props.activeModal}
          closeModal={props.closeModal}
        />
      );
    case MODALS.LIVE_TEMPLATE_ADD:
      return (
        <AddLiveTemplateSection
          leagues={props.leagues}
          setOpenModal={props.setOpenModal}
          activeModal={props.activeModal}
          closeModal={props.closeModal}
        />
      );
    case MODALS.TENNIS_LIVE_TEMPLATE_ADD:
      return (
        <TennisAddLiveTemplateSection
          leagues={props.leagues}
          setOpenModal={props.setOpenModal}
          activeModal={props.activeModal}
          closeModal={props.closeModal}
        />
      );
    case MODALS.PLAYERS_TEMPLATE_ADD_PREVIEW:
      return (
        <PlayersTemplatePreview
          templateFileSelectedId={props.modalData.playerTemplateFileId}
          competitionSelectedId={props.modalData.competitionId}
          setOpenModal={props.setOpenModal}
          activeModal={props.activeModal}
          closeModal={props.closeModal}
          leagues={props.leagues}
        />
      );
    default:
      return null;
  }
};
export default connect(mapToProps)(PlayersTemplateModals);
